import React from 'react';
export function ProductPresentation() {
  return <section className="w-full bg-sand-100 py-16 md:py-24 px-6" data-id="element-144">
      <div className="max-w-3xl mx-auto text-center" data-id="element-145">
        <h2 className="font-serif text-3xl md:text-5xl text-charcoal-700 mb-8 leading-tight uppercase tracking-wide" data-id="element-146">
          Florecer es ese acompañamiento que muchas veces falta
        </h2>

        <div className="text-lg md:text-xl text-charcoal-400 font-light leading-relaxed mb-10 space-y-3" data-id="element-147">
          <p data-id="element-148">No es solo información.</p>
          <p data-id="element-149">
            Es una guía pensada para ayudarte a transitar esta etapa con más
            calma, claridad y seguridad.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-150">
          {['Sin términos difíciles', 'Sin juicios', 'Sin exigencias irreales'].map((tag, index) => <div key={index} className="px-6 py-3 bg-sage-300/30 border border-sage-300 rounded-full text-charcoal-500 text-sm tracking-wider uppercase" data-id="element-151">
              {tag}
            </div>)}
        </div>
      </div>
    </section>;
}